import {Component, Input} from "@angular/core";

@Component({
  selector: 'app-shared-modal-header',
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.scss']
})
export class ModalHeaderComponent {

  private _title: string = "";
  private _subtitle: string | null = null;
  private _iconName: string = "";
  private _isDeleteModal: boolean = false

  get title(): string {
    return this._title;
  }

  @Input({required: true})
  set title(value: string) {
    this._title = value;
  }

  get subtitle(): string | null {
    return this._subtitle;
  }

  @Input()
  set subtitle(value: string | null) {
    this._subtitle = value;
  }

  get iconName(): string {
    return this._iconName;
  }

  @Input({required: true})
  set iconName(value: string) {
    this._iconName = value;
  }

  get isDeleteModal(): boolean {
    return this._isDeleteModal;
  }

  @Input({required: true})
  set isDeleteModal(value: boolean) {
    this._isDeleteModal = value;
  }
}
